module.exports = __webpack_public_path__ + "static/media/rush_bookmark_groucho_front_2x.74ba353f.jpg";